<div class="confirm-dialog">
  <div class="msg">{{ 'Are you sure you want to delete this tab?' | translate }}</div>
  <div class="confirm-buttons">
    <button class="btn cancel" (click)="finish(false)">{{ 'Cancel' | translate }}</button>
    <button class="btn yes" (click)="finish(true)">{{ 'Yes' | translate }}</button>
  </div>
</div>
